// Normalize scope value to 'site' or 'all'.
export function normalizeScope(rawScope) {
  return (rawScope || '').toLowerCase() === 'site' ? 'site' : 'all';
}

// Normalize sort mode value to 'relevance' or 'date'.
export function normalizeSortMode(rawSortMode) {
  return (rawSortMode || '').toLowerCase() === 'date' ? 'date' : 'relevance';
}

// Update active state on scope toggle buttons.
export function setActiveScope($toggle, scope) {
  $toggle.find('[data-search-scope]').removeClass('is-active');
  $toggle.find(`[data-search-scope="${scope}"]`).addClass('is-active');
}

// Update a single hidden form field to reflect the active search state.
function updateSearchStateHiddenField($form, fieldName, activeValue, selectedValue) {
  const $input = $form.find(`input[name="${fieldName}"]`);
  if ($input.length) {
    const isActive = selectedValue === activeValue;
    $input.val(isActive ? activeValue : '').prop('disabled', !isActive);
  }
}

// Build URL with current scope + sort state parameters.
export function buildSearchStateUrl(rawUrl, scope, sortMode) {
  const targetUrl = new URL(rawUrl, window.location.href);
  const updateParam = (key, value, activeValue) => {
    if (value === activeValue) targetUrl.searchParams.set(key, activeValue);
    else targetUrl.searchParams.delete(key);
  };
  updateParam('scope', scope, 'site');
  updateParam('sort', sortMode, 'date');
  return targetUrl.toString();
}

// Persist selected scope and sort mode in hidden form fields.
export function applySearchStateToForm($form, selectedScope, selectedSortMode) {
  if (!$form.length) {
    return;
  }
  updateSearchStateHiddenField($form, 'scope', 'site', selectedScope);
  updateSearchStateHiddenField($form, 'sort', 'date', selectedSortMode);
}
